export const Characters = [
    ['Isaac', '0'],
    ['Magdalena', '1'],
    ['Cain', '2'],
    ['Judas', '3'],
    ['Blue Baby', '4'],
    ['Eve', '5'],
    ['Samson', '6'],
    ['Azazel', '7'],
    ['Lazarus', '8'],
    ['Eden', '9'],
    ['The Lost', '10'],
    ['Lazarus', '11'],
    ['Black Judas', '12'],
    ['Lilith', '13'],
    ['Keeper', '14'],
    ['Apollyon', '15'],
    ['The Forgotten', '16'],
    ['The Soul', '17'],
    ['Bethany', '18'],
    ['Jacob', '19'],
    ['Esau', '20'],
    ['Tainted Isaac', '21'],
    ['Tainted Magdalena', '22'],
    ['Tainted Cain', '23'],
    ['Tainted Judas', '24'],
    ['Tainted Blue Baby', '25'],
    ['Tainted Eve', '26'],
    ['Tainted Samson', '27'],
    ['Tainted Azazel', '28'],
    ['Tainted Lazarus', '29'],
    ['Tainted Eden', '30'],
    ['Tainted The Lost', '31'],
    ['Tainted Lilith', '32'],
    ['Tainted Keeper', '33'],
    ['Tainted Apollyon', '34'],
    ['Tainted The Forgotten', '35'],
    ['Tainted Bethany', '36'],
    ['Tainted Jacob', '37'],
    ['Lazarus', '38'],
    ['Jacob', '39'],
    ['Tainted The Soul', '40'],
  ];
  